var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"error-image"},[_c('img',{attrs:{"src":_vm.$asAppAsset('/images/da-wtf.png')}})]),_c('div',{staticClass:"error-text"},[_vm._v(" 404 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }